import { Err, ResponseData } from 'types';

import { http } from '.';

export type MainUserPackagePlan = {
  id: number;
  mainUserId: string;
  price: number;
  packageCurrencyId: string;
  packageType: string;
  packagePeriodInDays: number;
  packagePeriodInMonth: string;
  isUpgradeEnabled: boolean;
};

export type SubUserPackagePlan = MainUserPackagePlan;

export type SubUserSubscriptionPlanRequest = {
  userId: string;
  packagePlanId: number;
};

export type CheckoutRequest = {
  amount: number;
  currencyCode: string;
  currencyText: string;
  userSubscriptionDetails: SubUserSubscriptionPlanRequest[];
};

export type CheckoutResponse = {
  url?: string;
  extra?: unknown[];
  refund?: unknown[];
  transactionList?: unknown[];
  code?: string;
  message?: string;
};

export const getPackagePlansForMainUsers = async () => {
  return await http.get<Err, ResponseData<any>>(
    `/Payment/PackagePlansForMainUsers`
  );
};

export const getPackagePlansForSubUsers = async () => {
  return await http.get<Err, ResponseData<any>>(
    `/Payment/PackagePlansForSubUsers`
  );
};

export const getUserSubscriptionPackagePlanAmount = async (
  payload: SubUserSubscriptionPlanRequest[]
) => {
  return await http.post<Err, ResponseData<any>>(
    `/Payment/GetUserSubscriptionPackagePlanAmount`,
    payload
  );
};

export const checkout = async (payload: CheckoutRequest) => {
  return await http.post<Err, ResponseData<CheckoutResponse>>(
    `/Payment/Checkout`,
    payload
  );
};
